var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.3334 1.33334L4.00008 8.66668L0.666748 5.33334","stroke":"#0B1E49","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none"};

module.exports = Check;

Check.default = Check;
